import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      props: {
        maxlength: 64
      },
      rules: [{ validator: validatorRequire }]
    },
    priority: {
      type: InputNumber,
      rules: [{ validator: validatorRequire }]
    }
  };
}
export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
